var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLockGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0fb11f",
    d: "M17.684 11.59a1.041 1.041 0 0 0-.768-.317h-.36V9.09c0-1.394-.497-2.59-1.49-3.59C14.073 4.5 12.884 4 11.5 4s-2.573.5-3.566 1.5c-.993 1-1.49 2.197-1.49 3.59v2.183h-.36c-.302 0-.557.106-.768.318-.21.212-.316.47-.316.773v6.545c0 .303.105.56.316.773.21.212.466.318.767.318h10.834c.3 0 .556-.106.767-.318.21-.212.316-.47.316-.773v-6.545c0-.303-.105-.56-.316-.773zm-3.295-.317H8.61V9.09c0-.803.282-1.489.846-2.057a2.774 2.774 0 0 1 2.043-.852c.798 0 1.478.284 2.043.852.564.568.846 1.254.846 2.057v2.182z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockGreen);
export default __webpack_public_path__ + "static/media/ic_lock_green.3d5db8c9ecfc45fdf19f142814cb0c38.svg";
export { ForwardRef as ReactComponent };